var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0233 5.46272C21.32 5.75172 21.3263 6.22656 21.0373 6.52329L8.8125 19.0749L2.96272 13.0687C2.67372 12.772 2.67998 12.2972 2.97671 12.0082C3.27344 11.7192 3.74828 11.7254 4.03728 12.0222L8.8125 16.9251L19.9627 5.47671C20.2517 5.17998 20.7266 5.17372 21.0233 5.46272Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.5c28926fd8e9bc0bbbe6ac76d753a12d.svg";
export { ForwardRef as ReactComponent };